import * as types from 'store/types'
const initialState = {
  team_templates: [],
  admin_template_categories: [],
  home_page_templates: [],
  home_response_packs: [],
  show_templates_modal: false,
  show_templates_sidebar: false,
  showResponseTemplates: false,
  openedResponseCategory: null
}

const templatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_TEMPLATES: {
      return initialState
    }
    // ADMIN TEMPLATES
    case types.SET_ADMIN_PAGE_TEMPLATES: {
      let home_page_templates = []
      let home_response_packs = []
      for (const cat of action.data) {
        if (cat.type === 'page') {
          home_page_templates = [...home_page_templates, ...cat.admin_templates.filter((t) => t.show_homepage)]
        } else if (cat.type === 'response' && cat.show_homepage) {
          home_response_packs = [...home_response_packs, cat]
        }
      }
      return {
        ...state,
        home_page_templates,
        home_response_packs,
        admin_template_categories: action.data
      }
    }
    // TEAM TEAMPLATES
    case types.SET_TEAM_PAGE_TEMPLATES: {
      return {
        ...state,
        team_templates: action.data
      }
    }
    case types.SET_NEW_TEMPLATE: {
      const data = state.team_templates
      if (data.map((d) => d.id).indexOf(action.data.id) === -1) {
        data.push(action.data)
      }
      return {
        ...state,
        team_templates: [...data]
      }
    }
    case types.SET_EDITED_TEMPLATE: {
      const data = state.team_templates
      const i = data.map((d) => d.id).indexOf(action.data.id)
      if (i !== -1) {
        data[i] = action.data
      }
      return {
        ...state,
        team_templates: [...data]
      }
    }
    case types.TOGGLE_TEMPLATES_MODAL: {
      return {
        ...state,
        show_templates_modal: action.value
      }
    }
    case types.TOGGLE_TEMPLATES_SIDEBAR: {
      return {
        ...state,
        show_templates_sidebar: action.value
      }
    }
    case types.TOGGLE_RESPONSE_TEMPLATES_MODAL: {
      return {
        ...state,
        showResponseTemplates: action.value,
        openedResponseCategory: action.categoryId || null
      }
    }
    default:
      return state
  }
}
export default templatesReducer
